import React, { Suspense, lazy } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import CustomLoading from "../Components/GeneralComponents/CustomLoading/customloading";
import { useDashboardBasePath } from "../i18n/hooks/useDashboardBasePath";
import { FeatureGate } from "../i18n/gates/FeatureGate";
import NonHebrewRouteBlock from "../i18n/gates/NonHebrewRouteBlock";
import { traceHotelSearchOnly } from "../i18n/routeTelemetry";

const PriceOffer = lazy(() => import("../Pages/Agent/PriceOffer/priceoffer"));
const HotelProfile = lazy(() => import("../Pages/Client/HotelProfile/hotelprofile"));

/**
 * Sprint 2+ — non-Hebrew agent dashboard: hotel search, profile, and offer.
 */
export function InternationalAgentDashboardBodyRoutes() {
  const dashboardBase = useDashboardBasePath();

  React.useEffect(() => {
    traceHotelSearchOnly({
      dashboardBase,
      routes: ["hotels/search", "hotels/profile/:hotelId", "hotels/offer/:offerId"],
    });
  }, [dashboardBase]);

  return (
    <Routes basename={dashboardBase}>
      <Route index element={<Navigate to="hotels/search" replace />} />
      <Route
        path="hotels/search"
        element={
          <FeatureGate feature="hotel_search">
            <Suspense fallback={<CustomLoading label="Loading hotel search..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          </FeatureGate>
        }
      />
      <Route
        path="hotels/profile/:hotelId"
        element={
          <FeatureGate feature="hotel_search">
            <Suspense fallback={<CustomLoading label="Loading hotel profile..." overlay size="large" />}>
              <HotelProfile handleHotelName={() => {}} />
            </Suspense>
          </FeatureGate>
        }
      />
      <Route
        path="hotels/offer/:offerId"
        element={
          <FeatureGate feature="hotel_search">
            <Suspense fallback={<CustomLoading label="Loading hotel offer..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          </FeatureGate>
        }
      />
      <Route path="*" element={<NonHebrewRouteBlock />} />
    </Routes>
  );
}

export default InternationalAgentDashboardBodyRoutes;
